define('entities/webshop/categories',[
  'app',
  'backbone',
  'settings',
  'underscore',
  'jquery',
  'bootbox',
  'backboneRelational'
], function (
  App,
  Backbone,
  Settings,
  _,
  $,
  Bootbox
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = {ns: Backbone.Relational.store._modelScopes[0]};
  } else {
    app = {ns: {}};
    Backbone.Relational.store.addModelScope(app.ns);
  }

  //-----------------

  app.ns.WebshopCategory = Backbone.RelationalModel.extend({
    idAttribute: 'id',
    fetch: function () {
      var params = {
        locale: Settings.get('lang'),
        id: this.getId()
      };

      this.url = Settings.url('compuzz2', 'webshop/category/get', params);
      return Backbone.Model.prototype.fetch.call(this);
    },

    parse: function (response, options) {
      if (response)
        API.create(response);

      return Backbone.Model.prototype.parse.call(this, response, options);
    },

    getId: function () {
      return parseInt(this.get('id'), 10);
    },

    getCode: function () {
      return this.get('code');
    },

    setCode: function (value) {
      var defer = $.Deferred();

      if (this.getCode() === value) {
        defer.resolve();
        return defer.promise();
      }

      this.update('code/update', value).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        this.trigger('change:code');
        defer.reject(e);
      }, this));

      return defer.promise();
    },

    getStatus: function () {
      return this.get('status');
    },

    setStatus: function (status) {
      var defer = $.Deferred();

      if (this.getStatus() === status) {
        defer.resolve();
        return defer.promise();
      }

      var data = {
        code: this.getCode(),
        status: status
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/status/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data.responseJSON.message);
          this.trigger('change:status');
        }
      });
      return defer.promise();
    },

    addProducts: function (ids) {
      var defer = $.Deferred();

      var data = {
        categoryId: this.getId(),
        productIds: ids
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/products/add'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data.responseJSON.message);
        }
      });
      return defer.promise();
    },

    addProductList: function (products) {
      var defer = $.Deferred();

      var data = {
        categoryId: this.getId(),
        products: products
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/products/add-list'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data.responseJSON.message);
        }
      });
      return defer.promise();
    },

    deleteProduct: function (id) {
      var defer = $.Deferred();

      var data = {
        categoryId: this.getId(),
        productId: id
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/products/delete'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data.responseJSON.message);
        }
      });
      return defer.promise();
    },

    updateProductPosition: function (ids, position) {
      var defer = $.Deferred();

      var data = {
        categoryId: this.getId(),
        productIds: ids,
        position: position
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/products/update-position'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data.responseText.message);
        }
      });
      return defer.promise();
    },

    getName: function (lang) {
      var name = this.getText('name', lang);
      if (name === '')
        name = this.get('label');
      return name;
    },

    setName: function (lang, value) {
      return this.setText('name', lang, value);
    },

    getLabel: function () {
      return this.get('label');
    },

    setLabel: function (value) {
      var defer = $.Deferred();

      if (this.getLabel() === value) {
        defer.resolve();
        return defer.promise();
      }

      this.update('label/update', value).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        defer.reject(e);
        this.trigger('change:label');
      }, this));

      return defer.promise();
    },

    getSeoLabel: function (lang) {
      return this.getText('filter-specific-name', lang);
    },

    setSeoLabel: function (lang, value) {
      return this.setText('filter-specific-name', lang, value);
    },

    getDescription: function (lang) {
      return this.getText('short', lang);
    },

    setDescription: function (lang, value) {
      return this.setText('short', lang, value);
    },

    getSeoProductDescription: function (lang) {
      return this.getText('product-description', lang);
    },

    setSeoProductDescription: function (lang, value) {
      return this.setText('product-description', lang, value);
    },

    getMetaTitle: function (lang) {
      return this.getText('title', lang);
    },

    setMetaTitle: function (lang, value) {
      return this.setText('title', lang, value);
    },

    getMetaDescription: function (lang) {
      return this.getText('meta-description', lang);
    },

    setMetaDescription: function (lang, value) {
      return this.setText('meta-description', lang, value);
    },

    getSlug: function (lang) {
      if (lang)
        return this.getText('url', lang);
      else
        return this.getText('url');
    },

    setSlug: function (lang, value) {
      return this.setText('url', lang, value);
    },

    getIndex: function (lang) {
      var result = true;

      if (this.get('noIndex')) {
        if (this.get('noIndex')[lang] !== undefined)
          result = this.get('noIndex')[lang];
      }

      return result;
    },

    setIndex: function (lang, value) {
      var defer = $.Deferred();

      if (this.getIndex(lang) === value) {
        defer.resolve();
        return defer.promise();
      }

      var data = {
        categorytId: this.getId(),
        lang: lang,
        value: value
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/seo/index/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data);
          this.trigger('change:noIndex');
        }
      });
      return defer.promise();
    },

    getLayout: function () {
      return this.get('layout');
    },

    setLayout: function (id) {
      var defer = $.Deferred();

      if (this.getLayout() === id) {
        defer.resolve();
        return defer.promise();
      }

      this.update('layout/update', id).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        defer.reject(e);
        this.trigger('change:layout');
      }, this));

      return defer.promise();
    },

    getProductsLayout: function () {
      return this.get('productsLayout');
    },

    setProductsLayout: function (id) {
      var defer = $.Deferred();

      if (this.getLayout() === id) {
        defer.resolve();
        return defer.promise();
      }

      this.update('products-layout/update', id).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        defer.reject(e);
        this.trigger('change:productLayout');
      }, this));

      return defer.promise();
    },

    getDefaultSort: function () {
      return this.get('defaultSort');
    },

    setDefaultSort: function (id) {
      var defer = $.Deferred();

      if (this.getLayout() === id) {
        defer.resolve();
        return defer.promise();
      }

      this.update('default-sort/update', id).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        defer.reject(e);
      }, this));

      return defer.promise();
    },

    getCategoriesCarouselVisibility: function () {
      return this.get('categoriesCarouselVisibility');
    },

    setCategoriesCarouselVisibility: function (value) {
      var defer = $.Deferred();

      if (this.getCategoriesCarouselVisibility() === value) {
        defer.resolve();
        return defer.promise();
      }
      this.update('categories-carousel/update', value).done(_.bind(function () {
        defer.resolve();
      }, this)).fail(_.bind(function (e) {
        defer.reject(e);
      }, this));
      return defer.promise();
    },

    getText: function (type, lang) {
      if (!lang)
        lang = Settings.get('lang');

      var text = '';
      if (this.get('texts')) {
        _.each(this.get('texts'), _.bind(function (t) {
          if (t.type === type && t.lang === lang)
            text = t.content;
        }, this));
      }
      return text;
    },

    setText: function (type, lang, value) {
      var defer = $.Deferred();

      if (this.getText(type, lang) === value) {
        defer.resolve();
        return defer.promise();
      }

      var data = {
        id: this.getId(),
        code: type,
        lang: lang,
        content: value
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/text/update'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (error) {
          Bootbox.alert(_.i18n('common.request.error'));
          defer.reject(error);
        }
      });
      return defer.promise();
    },

    getPreviewImageUrl: function () {
      var url = Settings.get('notFoundImage');
      if (this.get('medias')) {
        _.each(this.get('medias'), _.bind(function (media) {
          if (media.type === 'banner-image')
            url = Settings.configValue('webshop.imagesUrl') + '/' + media.previewUrl;
        }, this));
      }
      return url;
    },

    getImageUrls: function () {
      var urls = [];
      if (this.get('medias')) {
        _.each(this.get('medias'), _.bind(function (media) {
          urls.push(Settings.configValue('webshop.imagesUrl') + '/' + media.url);
        }, this));
      }
      return urls;
    },

    getImages: function (type) {

      var images = [];

      _.each(this.get('medias'), _.bind(function (media) {
        if(media.type === type)
          images.push(media);
      }, this));

      return images;
    },

    addImage: function (file, type) {
      var defer = $.Deferred();

      var data = new FormData();
      data.append('file', file);
      data.append('code', this.getCode());
      data.append('type', type);
    
      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/category/images/add'),
        data: data,
        processData: false,
        contentType: false,
        success: function (result) {
          var image = null;
          if(result.image)
            image = result.image;
          defer.resolve(image);
        },
        error: function (error) {
          defer.reject(error);
        }
      });
      return defer.promise();
    },

    deleteImage: function (id) {
      var defer = $.Deferred();

      var data = {
        categoryCode: this.getCode(),
        id: id
      };

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/category/images/delete'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    update: function(url, value) {
      var defer = $.Deferred();
      var data = {
        id: this.getId(),
        value: value
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/' + url),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data);
        }
      });
      return defer.promise();
    },

    clearCache: function () {
      var defer = $.Deferred();
      var data = {
        id: this.getId()
      };

      $.ajax({
        type: 'PUT',
        url: Settings.url('compuzz2', 'webshop/category/clean-cache'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data);
        }
      });
      return defer.promise();
    },

    redirect: function (targetDomain, targetId, type) {
      var defer = $.Deferred();

      var data = {
        originDomain: 'category',
        originId: this.getId(),
        targetDomain: targetDomain,
        targetId: targetId,
        type: type
      };

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/urls/redirect'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function (data) {
          defer.reject(data);
        }
      });

      return defer.promise();
    },

    removeRedirection: function () {
      var defer = $.Deferred();

      var data = {
        domain: 'category',
        id: this.getId()
      };

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/urls/remove-redirection'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function () {
          defer.reject();
        }
      });

      return defer.promise();
    }
  });

  var API = {
    create: function (data) {
      data.layout = '';
      data.productLayout = '';
      data.defaultSort = '';

      if (data.config) {
        _.each(data.config, _.bind(function (value, code) {
          if (code === 'layout')
            data.layout = value;
          if (code === 'products-layout')
            data.productsLayout = value;
          if (code === 'default-sort')
            data.defaultSort = value;
        }, this));
      }

      if (data.attributes) {
        /*_.each(data.attributes, _.bind(function (attribute) {
        }, this));*/
      }

      if (data.properties) {
        /*_.each(data.properties, _.bind(function (property) {
        }, this));*/
      }

      if (data.texts) {
        /*_.each(data.texts, _.bind(function (text) {
        }, this));*/
      }

      return data;
    },

    getImagesTypes: function () {
      var defer = $.Deferred();

      $.ajax({
        type: 'GET',
        url: Settings.url('compuzz2', 'webshop/categories/images/types', {}),
        success: _.bind(function (types) {
          defer.resolve(types);
        }, this)
      });
      return defer.promise();
    }
  };

  App.reqres.setHandler('webshop.category.model', function (data) {
    if (!data)
      data = {};
    return app.ns.WebshopCategory.findOrCreate(API.create(data));
  });

  App.reqres.setHandler('webshop.categories.search', function (params) {
    return Settings.url('compuzz2', 'webshop/categories/search', params);
  });

  // Mass update helpers (no model needed): add / remove a list of products to / from a category
  var updateCategoryProducts = function (url, categoryId, productIds) {
    var defer = $.Deferred();

    $.ajax({
      type: 'PUT',
      url: Settings.url('compuzz2', url),
      data: JSON.stringify({
        categoryId: categoryId,
        productIds: productIds
      }),
      processData: false,
      contentType: 'application/json',
      success: function () {
        defer.resolve();
      },
      error: function (xhr) {
        defer.reject(xhr && xhr.responseJSON ? xhr.responseJSON.message : null);
      }
    });

    return defer.promise();
  };

  App.reqres.setHandler('webshop.categories.products.add', function (categoryId, productIds) {
    return updateCategoryProducts('webshop/category/products/add', categoryId, productIds);
  });

  App.reqres.setHandler('webshop.categories.products.delete', function (categoryId, productIds) {
    return updateCategoryProducts('webshop/category/products/delete', categoryId, productIds);
  });

  App.reqres.setHandler('webshop.categories.count', function (params) {
    return Settings.url('compuzz2', 'webshop/categories/count', params);
  });

  App.reqres.setHandler('webshop.categories.tree', function (params) {
    return Settings.url('compuzz2', 'webshop/categories/tree', params);
  });

  App.reqres.setHandler('webshop.categories.tree.move', function () {
    return Settings.url('compuzz2', 'webshop/categories/tree/move/');
  });

  App.reqres.setHandler('webshop.category.history', function (id, params) {
    return Settings.url('compuzz2', 'webshop/category/' + id + '/index/history', params);
  });

  App.reqres.setHandler('webshop.category.urls', function (params) {
    return Settings.url('compuzz2', 'webshop/category/urls', params);
  });

  App.reqres.setHandler('webshop.category.history.count', function (id, params) {
    return Settings.url('compuzz2', 'webshop/category/' + id + '/index/history/count', params);
  });

  App.reqres.setHandler('webshop.category.products', function (id, params) {
    return Settings.url('compuzz2', 'webshop/category/' + id + '/products', params);
  });

  App.reqres.setHandler('webshop.category.products.import', function (id, params) {
    return Settings.url('compuzz2', 'webshop/category/' + id + '/products/import', params);
  });

  App.reqres.setHandler('webshop.category.products.count', function (id, params) {
    return Settings.url('compuzz2', 'webshop/category/' + id + '/products/count', params);
  });

  App.reqres.setHandler('webshop.category.products.positions', function (id) {
    return Settings.url('compuzz2', 'webshop/category/' + id + '/products/positions');
  });

  App.reqres.setHandler('webshop.categories.images.types', function () {
    return API.getImagesTypes();
  });
});

